import DataExchange from './DataExchange'

import QueryString from '@/utils/QueryString'

export default class SelectDataExchange extends DataExchange {
  queryParam
  /**
   * @param {HTMLFormElement} form
   * @param {HTMLSelectElement} select
   * @param {String} queryStringParamName name of query string parameter to look for selected values when initializing the object
   */
  constructor (form, select, queryStringParamName = null) {
    super(form)
    this.select = select
    this._queryParam = queryStringParamName
    this.initValuesFromQueryString(queryStringParamName)
  }

  get data () {
    if (!this.select || !this.select.options) {
      return []
    }
    return this.select.options.map(option => ({
      id: option.value,
      name: option.innerText,
      enabled: true,
      selected: option.selected,
      value: decodeURIComponent(option.value).split(','),
    }))
  }

  get queryComponent () {
    const selected = this.data.filter(option => option.selected)
    if (selected.length > 0) {
      return `${this._queryParam}=${selected.map(option => option.value).join(',')}`
    }
    return ''
  }

  /**
   * @param {Array} value
   */
  set data (value) {
    if (!this.select || !this.select.options) {
      return
    }
    this.select.options.forEach(option => {
      const item = value.find(d => d.id === option.value)
      if (item) {
        option.selected = item.selected
      } else {
        option.selected = false
      }
      if (option.selected) {
        option.setAttribute('checked', '')
      } else {
        option.removeAttribute('checked')
      }
    })
  }

  initValuesFromQueryString (paramName) {
    if (paramName === null) return

    const qs = new QueryString()
    if (qs.exists(paramName)) {
      const data = this.data
      const selected = qs.get(paramName).split(',')
      data.forEach(option => {
        option.selected = selected.some(v => option.value.indexOf(v) !== -1)
      })
      this.data = data
    }
  }
}



// WEBPACK FOOTER //
// ./src/services/SelectDataExchange.js